/**
 * @fileoverview Display metadata for each class kind.
 *
 * Mirrors the mobile app (`mobile/src/components/classKinds.js`). The
 * persisted value (`Class.kind` on the backend) is the snake_case `id` field.
 *
 * A kind is a LABEL, not a colour. Kinds once carried their own hues
 * (lavender, yellow, green), which put an off-brand purple on every studio
 * class; a class now wears the same quiet surface as the rest of the studio,
 * and --accent-yellow stays the one accent for what is active or selected.
 */

export const CLASS_KINDS = [
  {
    id: "studio_class",
    label: "Studio class",
    description: "Recurring shared lesson",
  },
  {
    id: "ensemble",
    label: "Ensemble",
    description: "Group performance, fixed roster",
  },
  {
    id: "cohort",
    label: "Cohort",
    description: "Time-bound, may be async",
  },
];

/** Return the full kind metadata object for an id, or the first kind as fallback. */
export function getClassKind(id) {
  return CLASS_KINDS.find((k) => k.id === id) || CLASS_KINDS[0];
}
